export default "__VITE_ASSET__DTmaWHYg__"